import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
interface CountdownTimerProps {
  initialTimeInSeconds: number;
  onComplete: () => void;
}
export function CountdownTimer({
  initialTimeInSeconds,
  onComplete
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(initialTimeInSeconds);
  useEffect(() => {
    if (timeLeft <= 0) {
      onComplete();
      return;
    }
    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft, onComplete]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex flex-col items-center py-6 text-center" data-id="element-33">
      <div className="flex items-center gap-2 mb-2 justify-center" data-id="element-34">
        <TimerIcon className="h-5 w-5 text-orange-500" data-id="element-35" />
        <p className="text-sm text-orange-400 font-medium" data-id="element-36">
          El próximo paso se desbloqueará en:
        </p>
      </div>
      <div className="px-8 py-4 rounded-lg text-center" data-id="element-37">
        <span className="text-3xl font-bold text-white" data-id="element-38">
          {minutes.toString().padStart(2, '0')}:
          {seconds.toString().padStart(2, '0')}
        </span>
      </div>
      <p className="mt-3 text-sm text-orange-300 max-w-md mx-auto" data-id="element-39">
        Por favor, mira el video completo para desbloquear toda la información y
        opciones de contacto
      </p>
    </div>;
}